import React from 'react';
import './BlackberryGallery.scss';

const images = [
    {
        src: '/assets/img/elnora/31.png',
        name: 'Wedding',
        size: 'wedding'
    },
    {
        src: '/assets/img/elnora/19.png',
        name: 'Haldi & Mehendi',
        size: 'haldi'
    },
    {
        src: '/assets/img/elnora/28.png',
        name: "Festive",
        size: 'festive'
    },
    {
        src: '/assets/img/elnora/23.png',
        name: "Bridal",
        size: 'bridal'
    },
    {
        src: '/assets/img/elnora/32.png',
        name: "Party",
        size: 'party'
    },
    {
        src: '/assets/img/elnora/16.png',
        name: "Workwear",
        size: 'workwear'
    }
];

const BlackberryGallery = () => {
    return (
        <div className="bb-gallery-section">
            <div className="bb-gallery-title">
                <h2>SHOP BY OCCASION</h2>
                <p>Life is an Occasion. Rise to it</p>
            </div>
            
            <div className="bb-gallery">
                <div className="bb-gallery-left-column">
                    <div className="bb-gallery-item wedding">
                        <div className="bb-gallery-image-container">
                            <img src={images[0].src} alt={images[0].name} />
                            <div className="bb-gallery-overlay">
                                <span className="name">{images[0].name}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="bb-gallery-right-column">
                    <div className="bb-gallery-top-row">
                        <div className="bb-gallery-item haldi">
                            <div className="bb-gallery-image-container">
                                <img src={images[1].src} alt={images[1].name} />
                                <div className="bb-gallery-overlay">
                                    <span className="name">{images[1].name}</span>
                                </div>
                            </div>
                        </div>
                        <div className="bb-gallery-item festive">
                            <div className="bb-gallery-image-container">
                                <img src={images[2].src} alt={images[2].name} />
                                <div className="bb-gallery-overlay">
                                    <span className="name">{images[2].name}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="bb-gallery-bottom-row">
                        <div className="bb-gallery-item bridal">
                            <div className="bb-gallery-image-container">
                                <img src={images[3].src} alt={images[3].name} />
                                <div className="bb-gallery-overlay">
                                    <span className="name">{images[3].name}</span>
                                </div>
                            </div>
                        </div>
                        <div className="bb-gallery-small-items">
                            <div className="bb-gallery-item party">
                                <div className="bb-gallery-image-container">
                                    <img src={images[4].src} alt={images[4].name} />
                                    <div className="bb-gallery-overlay">
                                        <span className="name">{images[4].name}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="bb-gallery-item workwear">
                                <div className="bb-gallery-image-container">
                                    <img src={images[5].src} alt={images[5].name} />
                                    <div className="bb-gallery-overlay">
                                        <span className="name">{images[5].name}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlackberryGallery;